import { logUserAdConfigLazy } from 'owa-aduser-log';
import { emailadsOptInStore } from 'owa-emailadsoptin-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    IsChildConsumerUser,
    IsPremiumConsumerUser,
    IsShadowMailboxUser,
    embargoedMarkets,
    getAdMarketPublishGroupCode,
    isEUEmailAdsPolicyMarket,
    isEUEmailAdsPolicyFeatureEnabled,
    getCachedEUEmailPolicyOptInBit,
} from 'owa-mail-ads-shared';

// enableDisplayAds means the display ad is enabled or not in the user session such as related to the premium user check, etc. The value will not change during the user session.
var enableDisplayAds: boolean;

// showDisplayAds means the Display Ad is shown or not from this check. The value could be changed during the whole session
var showDisplayAds: boolean;

export function areDisplayAdsShown(): boolean {
    // If the Ad is not enabled due to premium status or flight, etc, we do not need to check other dynamic properties
    if (!areDisplayAdsEnabled()) {
        return false;
    }

    // For EU Market, check if user has opted-in the optimized ads, if so, we turn off display Ad. This is a dynamic check during one session
    if (isEUEmailAdsPolicyMarket() && isEUEmailAdsPolicyFeatureEnabled()) {
        if (emailadsOptInStore.emailAdsOptInBit == 2) {
            return false;
        } else if (
            emailadsOptInStore.emailAdsOptInBit == -1 &&
            getCachedEUEmailPolicyOptInBit() == 2
        ) {
            return false;
        }
    }

    return true;
}

export function areDisplayAdsEnabled(): boolean {
    // caching this value as it doesn't change per session
    if (typeof showDisplayAds != 'undefined') {
        return showDisplayAds;
    }

    // Turn off the display Ad when one of the following conditions are met
    // 1. Not consumer user
    // 2. fwk-ads is turned off
    // 3. Running in Monarch
    if (
        !isConsumer() ||
        !isFeatureEnabled('fwk-ads') ||
        isHostAppFeatureEnabled('hideDisplayAds')
    ) {
        showDisplayAds = false;
    } else {
        let adsNotEnabledString = null;
        let adMarket = getAdMarketPublishGroupCode();

        // Make sure they have the AdsExperiments bit set and Display on is not set, then don't show ads
        if (IsPremiumConsumerUser()) {
            adsNotEnabledString = 'PremiumUser';
        } else if (IsShadowMailboxUser()) {
            adsNotEnabledString = 'ShadowMailboxUser';
        } else if (embargoedMarkets.includes(adMarket)) {
            adsNotEnabledString = 'EmbargoedMarket';
        } else if (IsChildConsumerUser()) {
            adsNotEnabledString = 'ChildAccount';
        }
        enableDisplayAds = adsNotEnabledString == null;
        showDisplayAds = adsNotEnabledString == null;

        if (enableDisplayAds && isFeatureEnabled('adsexp-DisplayOffNativeOn-treament')) {
            adsNotEnabledString = 'DisplayOffNativeOnAdExp';
            showDisplayAds = false;
        }

        if (
            enableDisplayAds &&
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2532 (60,14): Object is possibly 'undefined'.
            // @ts-expect-error
            !getUserConfiguration().UserOptions.IsFocusedInboxEnabled &&
            (isFeatureEnabled('adsExp-NativeInbox-e2-NoDisplayAd') ||
                isFeatureEnabled('adsExp-NativeInbox-e3-NoDisplayAd') ||
                isFeatureEnabled('adsExp-NativeInbox-e4-NoDisplayAd'))
        ) {
            adsNotEnabledString = 'NativeAdInboxNoDisplayAdExp';
            showDisplayAds = false;
        }

        logUserAdConfigLazy.importAndExecute(
            enableDisplayAds,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2345 (74,13): Argument of type 'null' is not assignable to parameter of type 'string'.
            // @ts-expect-error
            adsNotEnabledString,
            adMarket,
            showDisplayAds
        );
    }

    return showDisplayAds;
}

export function setShowAds(value: any) {
    showDisplayAds = value;
}
